(function () {
  'use strict';

  function initSticky() {
    var sticky = document.querySelector('[data-landing-sticky]');
    var heroBuyBtn = document.querySelector('.landing-kit__buy .mfs-btn--primary');
    if (!sticky || !heroBuyBtn) return;

    var show = function () {
      sticky.classList.add('is-visible');
      sticky.setAttribute('aria-hidden', 'false');
    };
    var hide = function () {
      sticky.classList.remove('is-visible');
      sticky.setAttribute('aria-hidden', 'true');
    };

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) hide(); else show();
        });
      }, { threshold: 0, rootMargin: '0px 0px -10% 0px' });
      observer.observe(heroBuyBtn);
    } else {
      window.addEventListener('scroll', function () {
        if (window.scrollY > 600) show(); else hide();
      }, { passive: true });
    }
  }

  function initThumbs() {
    var thumbs = document.querySelectorAll('[data-landing-thumb]');
    var mainImg = document.querySelector('[data-landing-main-img]');
    if (!thumbs.length || !mainImg) return;

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var src = thumb.getAttribute('data-src');
        var alt = thumb.getAttribute('data-alt') || '';
        if (!src) return;
        mainImg.removeAttribute('srcset');
        mainImg.removeAttribute('sizes');
        mainImg.setAttribute('src', src);
        mainImg.setAttribute('alt', alt);
        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initSticky();
      initThumbs();
    });
  } else {
    initSticky();
    initThumbs();
  }
})();
